import { render, staticRenderFns } from "./ModelCueWordView.vue?vue&type=template&id=6a9f53e6&scoped=true"
import script from "./ModelCueWordView.vue?vue&type=script&lang=js"
export * from "./ModelCueWordView.vue?vue&type=script&lang=js"
import style0 from "./ModelCueWordView.vue?vue&type=style&index=0&id=6a9f53e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9f53e6",
  null
  
)

export default component.exports